import { McoEndpointBuilder } from "./api/apiSlice";
import { apiClient } from "./api/useApi";
import { ApiTag } from "./api/util/ApiTag";

export const genesisCareAllImportRecordsTag = {
    type: ApiTag.IntegrationsGenesisCare,
    id: "record/all"
} as const
export const genesisCareAllImportResponsesTag = {
    type: ApiTag.IntegrationsGenesisCare,
    id: "response/all"
} as const

const genesisCareIntegrationEndpoints = (build: McoEndpointBuilder) => ({
    integrationGenesisCareReplaceApiResponse: build.mutation({
            queryFn: apiClient.integration.genesisCare.replayApiResponse,
            invalidatesTags: [
                ApiTag.Patient,
                ApiTag.PatientCondition,
                genesisCareAllImportResponsesTag
            ]
        }),
    integrationGenesisCareGetImportRecords: build.query({
        queryFn: (request: { pageSize: number; pageIndex: number }) =>
            apiClient.integration.genesisCare.getImportRecords(request),
        providesTags: (result) => [
            ApiTag.Tenant,
            ApiTag.Integrations,
            ApiTag.IntegrationsGenesisCare,
            ...(result?.importRecords.map(
                (x) =>
                    ({
                        type: ApiTag.IntegrationsGenesisCare,
                        id: `record/${x.recordId}`
                    }) as const
            ) ?? []),
            genesisCareAllImportRecordsTag
        ]
    }),
    integrationGenesisCareGetApiResponses: build.query({
        queryFn: (request: { pageSize: number; pageIndex: number }) =>
            apiClient.integration.genesisCare.getApiResponses(request),
        providesTags: (result) => [
            ApiTag.Tenant,
            ApiTag.Integrations,
            ApiTag.IntegrationsGenesisCare,
            genesisCareAllImportResponsesTag,
            ...(result?.importApiResponses.map(
                (x) =>
                    ({
                        type: ApiTag.IntegrationsGenesisCare,
                        id: `response/${x.requestDate}`
                    }) as const
            ) ?? [])
        ]
    }),
    integrationGenesisCareDeleteAllApiResponses: build.mutation({
        queryFn: (_: void) =>
            apiClient.integration.genesisCare.deleteAllApiResponses(),
        invalidatesTags: [genesisCareAllImportResponsesTag]
    })
})

export default genesisCareIntegrationEndpoints
